import React, { useState } from "react"
import FsLightbox from "fslightbox-react"
import "./demo.scss"

function SubscribeTwo({ location, errors }) {
  // LightBox Toggle State
  const [us, setUS] = useState(false)
  const [ca, setCA] = useState(false)

  const usFrame = (
    <div className="modal-contain">
      <iframe
        className="icontain-modal"
        src="https://meetings.hubspot.com/leo-skinner/worhub-discussion"
        width="90%"
        height="90%"
        scrolling="auto"
        frameBorder="0"
        allow="autoplay; fullscreen"
        allowFullScreen
        style={{ overflow: "auto" }}
      />
    </div>
  )

  const caFrame = (
    <div className="modal-contain">
      <iframe
        className="icontain-modal"
        src="https://meetings.hubspot.com/leo-skinner/worhub-discussion"
        width="90%"
        height="90%"
        scrolling="auto"
        frameBorder="0"
        style={{ overflow: "auto" }}
        allow="autoplay; fullscreen"
        allowFullScreen
      />
    </div>
  )

  return (
    <section className="payment_subscribe_area" data-section-id="closing_band">
      <div className="container">
        <div className="payment_subscribe_info">
          <div className="demo-cta-text-container">
            <h2 className="demo-cta-header-text">Still on the fence?</h2>
            <p className="demo-cta-body-text">
              Most organizations feel this way before upgrading. Try free for
              30 days, or book a quick call with someone who knows growing SMBs
            </p>
          </div>
          <div className="demo-cta-button-container">
            <button
              type="button"
              onClick={() => setCA(!ca)}
              className="demo-cta-button"
              data-track="cta"
              data-cta-id="site_closing_book_demo"
              data-cta-location="closing_band"
              data-cta-destination="hubspot_meeting"
            >
              Book A Demo
            </button>
            <FsLightbox toggler={ca} sources={[caFrame]} />
          </div>
        </div>
      </div>
    </section>
  )
}

export default SubscribeTwo